/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../../../../_metronic/helpers'
import {User} from '../../core/_models'

type Props = {
  User: User
}

const UserInfoCell: FC<Props> = ({User}) => {
  const timestamp = new Date().getTime()
  const [userImage, setUserImage] = useState(User.picture + '?' + timestamp)

  console.log('userImage', User)

  //in your component
  function erroImagem() {
    setUserImage(toAbsoluteUrl('/media/avatars/blank.png'))
  }

  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='symbol  symbol-circle symbol-50px overflow-hidden me-3'>
        <a href='#'>
          <div className='symbol-label'>
            <img src={userImage} alt={User.username} onError={erroImagem} className='w-100' />
          </div>
        </a>
      </div>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-primary mb-1'>
          {User.firstname} {User.lastname}
        </a>
        <span>{User.email}</span>
      </div>
    </div>
  )
}

export {UserInfoCell}
